import axios from "axios";

// Create an Axios instance
const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
  // headers: {
  //   "Content-Type": "application/json",
  // },
});

// Add request interceptor for authentication
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = ` ${token}`;
    }
    config.headers["ngrok-skip-browser-warning"] ="true";
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for error handling
API.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 404 errors gracefully
    if (error.response?.status === 404) {
      console.warn('API endpoint not found (404):', error.config?.url);
      return Promise.resolve({ data: null });
    }
    
    // Log other errors
    const errorMessage = error.response?.data?.message || error.message || 'An unexpected error occurred';
    console.error("API Error:", errorMessage);
    
    // Return a rejected promise with a consistent error format
    return Promise.reject({
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data
    });
  }
);

// Export reusable API methods
export const apiService = {
  get: (url, params) => API.get(url, { params }),
  post: (url, data) => API.post(url, data),
  put: (url, data) => API.put(url, data),
  delete: (url) => API.delete(url),
};
